import { memo, useCallback, useState } from 'react';

import { useStyles } from './RollingValue.styles';

type RollingValueProps = {
  value: string;
  className?: string;
};

type RollingValueState = {
  current: string;
  previous: string | null;
};

function RollingValueComponent({ value, className }: RollingValueProps) {
  const { classes, cx } = useStyles();
  const [state, setState] = useState<RollingValueState>({ current: value, previous: null });

  if (value !== state.current) {
    setState({ current: value, previous: state.current });
  }

  const handleAnimationEnd = useCallback(() => {
    setState((previousState) =>
      previousState.previous === null
        ? previousState
        : { current: previousState.current, previous: null }
    );
  }, []);

  const isRolling = state.previous !== null;

  return (
    <span className={cx(classes.root, className)}>
      <span
        key={state.current}
        className={isRolling ? classes.enter : undefined}
        onAnimationEnd={handleAnimationEnd}
      >
        {state.current}
      </span>
      {state.previous !== null && (
        <span key={state.previous} className={classes.exit} aria-hidden>
          {state.previous}
        </span>
      )}
    </span>
  );
}

export const RollingValue = memo(RollingValueComponent);

RollingValue.displayName = 'RollingValue';
